import React from 'react';
import { useEmptyState } from '../../hooks/useEmptyState';
import styles from './EmptyState.module.css';

const EmptyState = ({
    size = "Desktop 1440",
    type = "Discover SubCategory",
    categoryId = 1
}) => {
    const { width, content, isLoading, error } = useEmptyState({
        size,
        type,
        categoryId
    });

    if (error) {
        console.error('Error loading empty state:', error);
        return null;
    }

    if (isLoading) {
        return null; // O implementar un skeleton loader aquí
    }

    const { title, subtitle, buttonText, buttonLink } = content;

    return (
        <div className={styles.container}>
            <div 
                className={styles.contentContainer}
                style={{ width }}
            >
                <div className={styles.textContainer}>
                    <h1 className={styles.title}>{title}</h1>
                    <p className={styles.description}>{subtitle}</p>
                </div>
                {buttonText && (
                    <div
                        className={styles.button}
                        onClick={() => window.location.href = buttonLink}
                    >
                        <span className={styles.buttonText}>{buttonText}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default EmptyState;